import { proxy } from 'valtio';

export const environmentState = proxy({
  apiUrl: '',
  paypalClientId: '',
  countryCode: '',
});
